import { render } from "./TarjetaParada.vue?vue&type=template&id=373e627a&scoped=true"
import script from "./TarjetaParada.vue?vue&type=script&lang=js"
export * from "./TarjetaParada.vue?vue&type=script&lang=js"

import "./TarjetaParada.vue?vue&type=style&index=0&id=373e627a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373e627a"]])

export default __exports__